export const enum NpcType {
  Butler = 'butler',
  Doctor = 'doctor1',
  Doctor2 = 'doctor2',
  Nurse = 'nurse1',
  Nurse2 = 'nurse2'
}
